@use '@design/components/custom-scroll/custom-scroll' as *;

.scrollableContainer {
  @include custom-scroll-minimal;
  max-height: min(60vh, 480px);
  overflow-y: auto;
}

.tooltipWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 200px;
  margin-bottom: 12px;
  cursor: pointer;
  padding: 0;

  &:hover {
    background-color: var(--surface-hover);
  }
}
